export interface ICreateAttribute {
  name: { [key: string]: string };
  description: { [key: string]: string };
  attribute_group_id: string;
  tags: string[];
  image: File;
  image_url?: string;
  _method: "PUT" | "POST"
}
